var __rspack_ns_object = JSON.parse('{"Studies":"Études","Measurements":"Mesures","Measure":"Mesurer","Segmentation":"Segmentation"}')